export default [
  { url: "/regulamin", name: "Regulamin" },
  {
    url: "/polityka-cookies",
    name: "Polityka cookies",
  },
  { url: "/polityka-prywatnosci", name: "Polityka prywatności" },
  {
    // eslint-disable-next-line
    url: "javascript:Didomi.preferences.show()",
    name: "Ustawienia cookies",
    isAnchor: true,
  },
  { url: "/lp/payu.html", name: "Płatności PayU" },
  { url: "/lp/paypo.html", name: "Płatności PayPo" },
];
